import { useDispatch, useSelector } from 'react-redux';
import { Fragment, useEffect, useState } from 'react';
import { toggleFull } from '../../redux/slices/menu-click-slice';
import { useLocation, useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import { SidebarContainer, SidebarWrapper, SubMenusWrapper } from './sidebar-css';

const SidebarComponent = ({ menus: Menus, removePermissions, permissions }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.loginUserReducer);

    const { isOpen, isOpenFull } = useSelector((state) => state.menuClickReducer);

    const [states, setStates] = useState({
        selected: Menus[0],
    });

    const handleMainMenu = (e) => {
        if (e.subMenus?.length > 0) {
            setStates((old) => ({ ...old, selected: e }));

            const hasDifferentSubMenus = JSON.stringify(e.subMenus) !== JSON.stringify(states.selected?.subMenus);
            if (isOpenFull && hasDifferentSubMenus) {} else {
                dispatch(toggleFull());
            }
        }
    };

    const handleSubMenu = (e) => {
        if(e && e.length > 0 && !user?.firstLogin) {
            navigate(e);
        }
        dispatch(toggleFull());
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.sidebar-wrapper') && !event.target.closest('.menu-container')) {
                if (isOpenFull) {
                    dispatch(toggleFull());
                }
            }
        };
  
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpenFull]); // eslint-disable-line react-hooks/exhaustive-deps

    const MAIN_MENU = ({ item }) => (
        <div className={`${location.pathname.includes(item.to) ? 'active' : ''} menu`} onClick={() => handleMainMenu(item)}>
            <div className='line'></div>
            <div className='content'>
                <item.icon />
                <p>{item.label}</p>
            </div>
        </div>
    );

    const SUB_MENU = ({ item }) => (
        <div className={`${location.pathname.includes(item.to) ? 'active' : ''} submenu`} onClick={() => handleSubMenu(item.to)}>
            <item.icon />
            <p>{item.label}</p>
        </div>
    );

    return (
        <SidebarWrapper className={`${isOpen ? 'sidebar-open' : 'sidebar-close'} sidebar-wrapper box-shadow`}>
            {/* SUB MENUS */}
            <SubMenusWrapper className={`${isOpenFull ? 'sidebar-open-full' : 'sidebar-close-full'} custom-scrollbar box-shadow`}>
                <div className='sidebar-sub-menus-container'>
                    {
                        states.selected && states.selected.subMenus.length > 0 && states.selected.subMenus.map((item, index) => (
                            <Fragment key={index}>
                                {
                                    !removePermissions && permissions && permissions.length > 0 && permissions?.some(permission => permission?.pageUrl === item?.to) &&
                                    <SUB_MENU item={item} />
                                }
                                {
                                    removePermissions &&
                                    <SUB_MENU item={item} />
                                }
                            </Fragment>
                        ))
                    }
                </div>
            </SubMenusWrapper>

            {/* MAIN MENUS */}
            <SidebarContainer $isopenfull={!isOpenFull} className='custom-scrollbar'>
                {
                    Menus && Menus.length > 0 && Menus.map((item, index) => (
                        <Fragment key={index}>
                            {
                                !removePermissions && permissions && permissions.length > 0 && permissions?.some(permission => permission?.pageUrl === item?.to) &&
                                <MAIN_MENU item={item} />
                            }
                            {
                                removePermissions &&
                                <MAIN_MENU item={item} />
                            }
                        </Fragment>
                    ))
                }
            </SidebarContainer>
        </SidebarWrapper>
    );
};

SidebarComponent.propTypes = {
    menus: PropTypes.array.isRequired,
    removePermissions: PropTypes.bool,
    permissions: PropTypes.array,
};

export default SidebarComponent;